// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import TemplateContract from './TemplateContract';

type Args = {
  instrumentId: string;
  registrar: string;
  holdings: TemplateContract<Holding>[];
};
export const filterHoldingsByInstrument = (arg: Args) => {
  const { instrumentId, registrar, holdings } = arg;
  return holdings.filter(
    (h) => h.payload.instrument.id === instrumentId && h.payload.instrument.source === registrar,
  );
};
